import { generateResourceSelectors } from '../generators/resource.selectors';
import * as types from './account-project.types';
export const accountProjectSelectors = {
  ...generateResourceSelectors<types.IAccountProject>((state) => state.resource.accountProject),
};
